let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("hxgY7"), load("5XVGB"), load("6wr18"), load("hhss7"), load("ffEVr"), load("kUbT8")]).then(() => parcelRequire('4KbgO'));